module.exports = __webpack_public_path__ + "img/activity-air.658da360.svg";